import React from 'react'

import { Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import FilterListIcon from '@material-ui/icons/FilterList'
import SearchIcon from '@material-ui/icons/Search'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import loadAndActivateVectorLayer from 'api/loadAndActivateVectorLayer'
import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import { closeTable, openTable, setTableStatus } from 'drawer/tabs/layers/table/actions'
import { TABLE_STATUS_OPENING, TABLE_STATUS_OPENED } from 'drawer/tabs/layers/table/LayerTable'
import Loading from 'utils/Loading'
import PoziNotifications from 'utils/notifications'

const styles = theme => ({
  helpText: {
    marginBottom: 12,
    marginLeft: 6
  },
  helpTextBox: {
    marginBottom: 35,
    marginTop: 12
  },
  helpTextIcon: {
    marginRight: 6,
    opacity: 0.54,
    width: 24
  },
  loading: {
    alignSelf: 'center'
  },
  searchAdvancedButton: {
    fontWeight: 400,
    justifyContent: 'left',
    marginRight: 6,
    marginTop: 6
  },
  searchAdvancedDiv: {
    columnGap: 20,
    display: 'flex',
    flexDirection: 'row'
  }
})

class SearchAdvancedButton extends React.PureComponent {
  onClick = () => {
    const { dispatchCloseTable, dispatchOpenTable, dispatchSetTableStatus } = this.props

    const selectedLayer = Model.get('app.search.layer', null)
    const titleid = selectedLayer?.titleid || ''

    if (!titleid) {
      PoziNotifications().warning('Something went wrong. Layer could not be found.')

      console.log('SearchAdvancedButton - onClick layer not found', selectedLayer)

      return
    }

    dispatchCloseTable()

    dispatchSetTableStatus(TABLE_STATUS_OPENING)

    // An asynchronous function with a timeout is required to avoid the application locking when fetching data from a large data table.
    // Without this the button won't become disabled and the loading icon won't appear, so the user may think nothing is happening.
    window.setTimeout(async () => {
      const layerConf = PoziUtils.getLayerFromTitleID(titleid)
      const layerData = await loadAndActivateVectorLayer(layerConf)

      dispatchOpenTable(titleid, layerData)
    }, 100)
  }

  render () {
    const { classes, tableStatus } = this.props

    const tableOpening = tableStatus === TABLE_STATUS_OPENING
    const tableOpened = tableStatus === TABLE_STATUS_OPENED

    return (
      <div>
        <div className={classes.searchAdvancedDiv}>
          <Button className={classes.searchAdvancedButton} onClick={this.onClick} disabled={tableOpening}>
            Advanced...
          </Button>
          <div className={classes.loading}>
            { tableOpening && <Loading text="" /> }
          </div>
        </div>
        { tableOpened && (
          <div className={classes.helpTextBox}>
            <div className={classes.helpText}>
              <SearchIcon className={classes.helpTextIcon} />
              To search, click the Search button below
            </div>
            <div className={classes.helpText}>
              <FilterListIcon className={classes.helpTextIcon} />
              To filter, click the Filter button below
            </div>
          </div>
        )}
      </div>
    )
  }
}

SearchAdvancedButton.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatchCloseTable: PropTypes.func.isRequired,
  dispatchOpenTable: PropTypes.func.isRequired,
  dispatchSetTableStatus: PropTypes.func.isRequired,
  tableStatus: PropTypes.string.isRequired
}

function mapStateToProps (state, ownProps) {
  const tableStatus = state.table.status

  return {
    tableStatus
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatchOpenTable: (titleid, data) => {
      dispatch(openTable(titleid, data))
    },
    dispatchCloseTable: () => {
      dispatch(closeTable())
    },
    dispatchSetTableStatus: (status) => {
      dispatch(setTableStatus(status))
    }
  }
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SearchAdvancedButton)
  )
)
